// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AbrirTiendaEnEspanaRouteImport } from './routes/abrir-tienda-en-espana'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AgenteIaRouteImport } from './routes/agente-ia'
import { Route as AgenteRetailIaRouteImport } from './routes/agente-retail-ia'
import { Route as AnalisisCompletoRouteImport } from './routes/analisis-completo'
import { Route as AromaParaTuLocalRouteImport } from './routes/aroma-para-tu-local'
import { Route as AvisoLegalRouteImport } from './routes/aviso-legal'
import { Route as CadenasYFranquiciasRouteImport } from './routes/cadenas-y-franquicias'
import { Route as CalculadoraRouteImport } from './routes/calculadora'
import { Route as CalculadoraRentabilidadRetailRouteImport } from './routes/calculadora-rentabilidad-retail'
import { Route as CasosRealesRetailRouteImport } from './routes/casos-reales-retail'
import { Route as ColaboradoresRouteImport } from './routes/colaboradores'
import { Route as ComoFuncionaRouteImport } from './routes/como-funciona'
import { Route as CondicionesContratacionRouteImport } from './routes/condiciones-contratacion'
import { Route as ConsejosRouteImport } from './routes/consejos'
import { Route as ConsultasResueltasRouteImport } from './routes/consultas-resueltas'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ContactoRouteImport } from './routes/contacto'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as CuentanostucasoRouteImport } from './routes/cuentanostucaso'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DetectorDeFugasRouteImport } from './routes/detector-de-fugas'
import { Route as DiagnosticadorLocalesRouteImport } from './routes/diagnosticador-locales'
import { Route as DiagnosticoLocalesComercialesRouteImport } from './routes/diagnostico-locales-comerciales'
import { Route as EditorialRouteImport } from './routes/editorial'
import { Route as EstrategiaRouteImport } from './routes/estrategia'
import { Route as FamilyOfficesInversoresRouteImport } from './routes/family-offices-inversores'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as GoRouteImport } from './routes/go'
import { Route as HerramientasParaRetailRouteImport } from './routes/herramientas-para-retail'
import { Route as HojaDeRutaRouteImport } from './routes/hoja-de-ruta'
import { Route as LegalNoticeRouteImport } from './routes/legal-notice'
import { Route as LemonThermometerRouteImport } from './routes/lemon-thermometer'
import { Route as LocationDiagnosisRouteImport } from './routes/location-diagnosis'
import { Route as MarketingRouteImport } from './routes/marketing'
import { Route as MensajesRouteImport } from './routes/mensajes'
import { Route as MentoriaRouteImport } from './routes/mentoria'
import { Route as MentoriaRetailRouteImport } from './routes/mentoria-retail'
import { Route as MentoringRouteImport } from './routes/mentoring'
import { Route as MessagesRouteImport } from './routes/messages'
import { Route as MisLocalesRouteImport } from './routes/mis-locales'
import { Route as MusicaParaTuLocalRouteImport } from './routes/musica-para-tu-local'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PresupuestosRouteImport } from './routes/presupuestos'
import { Route as PrivacidadRouteImport } from './routes/privacidad'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ProblemasEnMiTiendaRouteImport } from './routes/problemas-en-mi-tienda'
import { Route as ProfesionalesRetailRouteImport } from './routes/profesionales-retail'
import { Route as ProveedoresRouteImport } from './routes/proveedores'
import { Route as PublicacionesParaTuLocalRouteImport } from './routes/publicaciones-para-tu-local'
import { Route as QueEsElAgenteRetailIaRouteImport } from './routes/que-es-el-agente-retail-ia'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RetailLocationAnalysisRouteImport } from './routes/retail-location-analysis'
import { Route as RetailProfitabilityCalculatorRouteImport } from './routes/retail-profitability-calculator'
import { Route as TarifasRouteImport } from './routes/tarifas'
import { Route as TermometroRouteImport } from './routes/termometro'
import { Route as TermometroLemonRouteImport } from './routes/termometro-lemon'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as TestModalRouteImport } from './routes/test-modal'
import { Route as TestModalProRouteImport } from './routes/test-modal-pro'
import { Route as TestSupervivenciaRouteImport } from './routes/test-supervivencia'
import { Route as TodoParaTuComercioRouteImport } from './routes/todo-para-tu-comercio'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAnaliticaRouteImport } from './routes/admin/analitica'
import { Route as AdminAsistentesRouteImport } from './routes/admin/asistentes'
import { Route as AdminCalculatorRouteImport } from './routes/admin/calculator'
import { Route as AdminCasosRealesRouteImport } from './routes/admin/casos-reales'
import { Route as AdminChatRouteImport } from './routes/admin/chat'
import { Route as AdminClubProRouteImport } from './routes/admin/club-pro'
import { Route as AdminComentariosModulosRouteImport } from './routes/admin/comentarios-modulos'
import { Route as AdminComparativaPlanesRouteImport } from './routes/admin/comparativa-planes'
import { Route as AdminConsumoIaRouteImport } from './routes/admin/consumo-ia'
import { Route as AdminDemoRouteImport } from './routes/admin/demo'
import { Route as AdminDiagnosticadorLocalesRouteImport } from './routes/admin/diagnosticador-locales'
import { Route as AdminDiagnosticoRouteImport } from './routes/admin/diagnostico'
import { Route as AdminEmailsRouteImport } from './routes/admin/emails'
import { Route as AdminEmbudoRouteImport } from './routes/admin/embudo'
import { Route as AdminErroresRouteImport } from './routes/admin/errores'
import { Route as AdminFacturacionRouteImport } from './routes/admin/facturacion'
import { Route as AdminFacturasRouteImport } from './routes/admin/facturas'
import { Route as AdminFinanzasRouteImport } from './routes/admin/finanzas'
import { Route as AdminHeroMessagingRouteImport } from './routes/admin/hero-messaging'
import { Route as AdminInsightsRouteImport } from './routes/admin/insights'
import { Route as AdminLandingsRouteImport } from './routes/admin/landings'
import { Route as AdminLeadsRouteImport } from './routes/admin/leads'
import { Route as AdminLocalesActivosRouteImport } from './routes/admin/locales-activos'
import { Route as AdminMindsetQuotesRouteImport } from './routes/admin/mindset-quotes'
import { Route as AdminPaymentsRouteImport } from './routes/admin/payments'
import { Route as AdminPeticionesHerramientasRouteImport } from './routes/admin/peticiones-herramientas'
import { Route as AdminPlanesRouteImport } from './routes/admin/planes'
import { Route as AdminPresupuestosRouteImport } from './routes/admin/presupuestos'
import { Route as AdminPricingRouteImport } from './routes/admin/pricing'
import { Route as AdminPricingSettingsRouteImport } from './routes/admin/pricing-settings'
import { Route as AdminProfesionalesRouteImport } from './routes/admin/profesionales'
import { Route as AdminQuizRouteImport } from './routes/admin/quiz'
import { Route as AdminRoadmapRouteImport } from './routes/admin/roadmap'
import { Route as AdminSolucionesRouteImport } from './routes/admin/soluciones'
import { Route as AdminSubvencionesRouteImport } from './routes/admin/subvenciones'
import { Route as AdminSupportAgentRouteImport } from './routes/admin/support-agent'
import { Route as AdminTipsRouteImport } from './routes/admin/tips'
import { Route as AdminToursRouteImport } from './routes/admin/tours'
import { Route as AdminVipCalendarRouteImport } from './routes/admin/vip-calendar'
import { Route as AdminWaitlistRouteImport } from './routes/admin/waitlist'
import { Route as AuthErrorRouteImport } from './routes/auth/error'
import { Route as CasosRealesIndexRouteImport } from './routes/casos-reales/index'
import { Route as CasosRealesSlugRouteImport } from './routes/casos-reales/$slug'
import { Route as CheckoutExitoRouteImport } from './routes/checkout/exito'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout/success'
import { Route as ConsultasResueltasIndexRouteImport } from './routes/consultas-resueltas.index'
import { Route as CuentaFacturacionRouteImport } from './routes/cuenta/facturacion'
import { Route as CuentaPerfilRouteImport } from './routes/cuenta/perfil'
import { Route as CuentaPresupuestosRouteImport } from './routes/cuenta/presupuestos'
import { Route as DebugLogsRouteImport } from './routes/debug/logs'
import { Route as EnIndexRouteImport } from './routes/en/index'
import { Route as EnAiAgentRouteImport } from './routes/en/ai-agent'
import { Route as EnAnswersRouteImport } from './routes/en/answers'
import { Route as EnChainsAndFranchisesRouteImport } from './routes/en/chains-and-franchises'
import { Route as EnContactRouteImport } from './routes/en/contact'
import { Route as EnCookiesRouteImport } from './routes/en/cookies'
import { Route as EnDashboardRouteImport } from './routes/en/dashboard'
import { Route as EnEditorialRouteImport } from './routes/en/editorial'
import { Route as EnEverythingForYourStoreRouteImport } from './routes/en/everything-for-your-store'
import { Route as EnFamilyOfficesInvestorsRouteImport } from './routes/en/family-offices-investors'
import { Route as EnFaqRouteImport } from './routes/en/faq'
import { Route as EnGoRouteImport } from './routes/en/go'
import { Route as EnHowItWorksRouteImport } from './routes/en/how-it-works'
import { Route as EnLeakDetectorRouteImport } from './routes/en/leak-detector'
import { Route as EnLegalNoticeRouteImport } from './routes/en/legal-notice'
import { Route as EnLemonThermometerRouteImport } from './routes/en/lemon-thermometer'
import { Route as EnMarketingRouteImport } from './routes/en/marketing'
import { Route as EnMentoringRouteImport } from './routes/en/mentoring'
import { Route as EnMusicForYourStoreRouteImport } from './routes/en/music-for-your-store'
import { Route as EnOpenAStoreInSpainRouteImport } from './routes/en/open-a-store-in-spain'
import { Route as EnPartnersRouteImport } from './routes/en/partners'
import { Route as EnPricingRouteImport } from './routes/en/pricing'
import { Route as EnPrivacyPolicyRouteImport } from './routes/en/privacy-policy'
import { Route as EnRetailAiAgentRouteImport } from './routes/en/retail-ai-agent'
import { Route as EnRetailExpertsRouteImport } from './routes/en/retail-experts'
import { Route as EnRetailLocationAnalysisRouteImport } from './routes/en/retail-location-analysis'
import { Route as EnRetailProfitabilityCalculatorRouteImport } from './routes/en/retail-profitability-calculator'
import { Route as EnRetailRoadmapRouteImport } from './routes/en/retail-roadmap'
import { Route as EnRetailSurvivalTestRouteImport } from './routes/en/retail-survival-test'
import { Route as EnScentForYourStoreRouteImport } from './routes/en/scent-for-your-store'
import { Route as EnSocialPostsForYourStoreRouteImport } from './routes/en/social-posts-for-your-store'
import { Route as EnStoreProblemsRouteImport } from './routes/en/store-problems'
import { Route as EnStrategyRouteImport } from './routes/en/strategy'
import { Route as EnSuppliersRouteImport } from './routes/en/suppliers'
import { Route as EnTarifasRouteImport } from './routes/en/tarifas'
import { Route as EnTermsRouteImport } from './routes/en/terms'
import { Route as EnTipsRouteImport } from './routes/en/tips'
import { Route as EnToolsForRetailRouteImport } from './routes/en/tools-for-retail'
import { Route as EnWhatIsTheRetailAiAgentRouteImport } from './routes/en/what-is-the-retail-ai-agent'
import { Route as GuiasIndexRouteImport } from './routes/guias/index'
import { Route as GuiasSlugRouteImport } from './routes/guias/$slug'
import { Route as HerramientasIndexRouteImport } from './routes/herramientas/index'
import { Route as HerramientasAnalisisCompletoRouteImport } from './routes/herramientas/analisis-completo'
import { Route as HerramientasCalculadoraRouteImport } from './routes/herramientas/calculadora'
import { Route as HerramientasKpisRouteImport } from './routes/herramientas/kpis'
import { Route as HerramientasMisLocalesRouteImport } from './routes/herramientas/mis-locales'
import { Route as HerramientasPresupuestosRouteImport } from './routes/herramientas/presupuestos'
import { Route as HerramientasProveedoresRouteImport } from './routes/herramientas/proveedores'
import { Route as HerramientasTermometroRouteImport } from './routes/herramientas/termometro'
import { Route as InsightsIndexRouteImport } from './routes/insights/index'
import { Route as InsightsSlugRouteImport } from './routes/insights/$slug'
import { Route as LpInstagramRouteImport } from './routes/lp/instagram'
import { Route as LpSupervivenciaRouteImport } from './routes/lp/supervivencia'
import { Route as LpTestSupervivenciaRouteImport } from './routes/lp/test-supervivencia'
import { Route as PanelIndexRouteImport } from './routes/panel/index'
import { Route as PanelCalculadoraProRouteImport } from './routes/panel/calculadora-pro'
import { Route as PanelCasosRouteImport } from './routes/panel/casos'
import { Route as PanelSubvencionesRouteImport } from './routes/panel/subvenciones'
import { Route as RecursosSubvencionesRouteImport } from './routes/recursos/subvenciones'
import { Route as SubvencionesIndexRouteImport } from './routes/subvenciones/index'
import { Route as SubvencionesCodigoRouteImport } from './routes/subvenciones/$codigo'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable/oauth/consent'
import { Route as AdminCrmIndexRouteImport } from './routes/admin/crm/index'
import { Route as ConsultasResueltasSectorPreguntaRouteImport } from './routes/consultas-resueltas.$sector.$pregunta'
import { Route as EnAccountBillingRouteImport } from './routes/en/account/billing'
import { Route as EnAccountProfileRouteImport } from './routes/en/account/profile'
import { Route as EnAccountQuotesRouteImport } from './routes/en/account/quotes'
import { Route as EnAnswersIndexRouteImport } from './routes/en/answers.index'
import { Route as EnGrantsIndexRouteImport } from './routes/en/grants/index'
import { Route as EnGrantsCodigoRouteImport } from './routes/en/grants/$codigo'
import { Route as EnGuidesIndexRouteImport } from './routes/en/guides/index'
import { Route as EnGuidesSlugRouteImport } from './routes/en/guides/$slug'
import { Route as EnInsightsIndexRouteImport } from './routes/en/insights/index'
import { Route as EnInsightsSlugRouteImport } from './routes/en/insights/$slug'
import { Route as EnLpInstagramRouteImport } from './routes/en/lp/instagram'
import { Route as EnPanelIndexRouteImport } from './routes/en/panel/index'
import { Route as EnPanelCasesRouteImport } from './routes/en/panel/cases'
import { Route as EnPanelGrantsRouteImport } from './routes/en/panel/grants'
import { Route as EnPanelProCalculatorRouteImport } from './routes/en/panel/pro-calculator'
import { Route as EnRealCasesIndexRouteImport } from './routes/en/real-cases/index'
import { Route as EnRealCasesSlugRouteImport } from './routes/en/real-cases/$slug'
import { Route as EnResourcesSubsidiesRouteImport } from './routes/en/resources/subsidies'
import { Route as EnToolsIndexRouteImport } from './routes/en/tools.index'
import { Route as EnToolsCalculatorRouteImport } from './routes/en/tools/calculator'
import { Route as EnToolsKpisRouteImport } from './routes/en/tools/kpis'
import { Route as EnToolsLemonThermometerRouteImport } from './routes/en/tools/lemon-thermometer'
import { Route as EnToolsMyPremisesRouteImport } from './routes/en/tools/my-premises'
import { Route as EnToolsProposalsRouteImport } from './routes/en/tools/proposals'
import { Route as EnToolsSuppliersRouteImport } from './routes/en/tools/suppliers'
import { Route as SubvencionesSectorSectorRouteImport } from './routes/subvenciones/sector.$sector'
import { Route as SubvencionesTerritorioComunidadRouteImport } from './routes/subvenciones/territorio.$comunidad'
import { Route as AdminCrmUserIdIndexRouteImport } from './routes/admin/crm/$userId/index'
import { Route as AdminCrmUserIdPanelRouteImport } from './routes/admin/crm/$userId/panel'
import { Route as CuentaHistorialDiagnosticoSessionIdRouteImport } from './routes/cuenta/historial/diagnostico/$sessionId'
import { Route as EnAnswersSectorQuestionRouteImport } from './routes/en/answers.$sector.$question'
import { Route as EnGrantsRegionComunidadRouteImport } from './routes/en/grants/region.$comunidad'
import { Route as EnGrantsSectorSectorRouteImport } from './routes/en/grants/sector.$sector'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AbrirTiendaEnEspanaRoute = AbrirTiendaEnEspanaRouteImport.update({
            id: '/abrir-tienda-en-espana',path: '/abrir-tienda-en-espana',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AgenteIaRoute = AgenteIaRouteImport.update({
            id: '/agente-ia',path: '/agente-ia',getParentRoute: () => rootRouteImport
          })
const AgenteRetailIaRoute = AgenteRetailIaRouteImport.update({
            id: '/agente-retail-ia',path: '/agente-retail-ia',getParentRoute: () => rootRouteImport
          })
const AnalisisCompletoRoute = AnalisisCompletoRouteImport.update({
            id: '/analisis-completo',path: '/analisis-completo',getParentRoute: () => rootRouteImport
          })
const AromaParaTuLocalRoute = AromaParaTuLocalRouteImport.update({
            id: '/aroma-para-tu-local',path: '/aroma-para-tu-local',getParentRoute: () => rootRouteImport
          })
const AvisoLegalRoute = AvisoLegalRouteImport.update({
            id: '/aviso-legal',path: '/aviso-legal',getParentRoute: () => rootRouteImport
          })
const CadenasYFranquiciasRoute = CadenasYFranquiciasRouteImport.update({
            id: '/cadenas-y-franquicias',path: '/cadenas-y-franquicias',getParentRoute: () => rootRouteImport
          })
const CalculadoraRoute = CalculadoraRouteImport.update({
            id: '/calculadora',path: '/calculadora',getParentRoute: () => rootRouteImport
          })
const CalculadoraRentabilidadRetailRoute = CalculadoraRentabilidadRetailRouteImport.update({
            id: '/calculadora-rentabilidad-retail',path: '/calculadora-rentabilidad-retail',getParentRoute: () => rootRouteImport
          })
const CasosRealesRetailRoute = CasosRealesRetailRouteImport.update({
            id: '/casos-reales-retail',path: '/casos-reales-retail',getParentRoute: () => rootRouteImport
          })
const ColaboradoresRoute = ColaboradoresRouteImport.update({
            id: '/colaboradores',path: '/colaboradores',getParentRoute: () => rootRouteImport
          })
const ComoFuncionaRoute = ComoFuncionaRouteImport.update({
            id: '/como-funciona',path: '/como-funciona',getParentRoute: () => rootRouteImport
          })
const CondicionesContratacionRoute = CondicionesContratacionRouteImport.update({
            id: '/condiciones-contratacion',path: '/condiciones-contratacion',getParentRoute: () => rootRouteImport
          })
const ConsejosRoute = ConsejosRouteImport.update({
            id: '/consejos',path: '/consejos',getParentRoute: () => rootRouteImport
          })
const ConsultasResueltasRoute = ConsultasResueltasRouteImport.update({
            id: '/consultas-resueltas',path: '/consultas-resueltas',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ContactoRoute = ContactoRouteImport.update({
            id: '/contacto',path: '/contacto',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const CuentanostucasoRoute = CuentanostucasoRouteImport.update({
            id: '/cuentanostucaso',path: '/cuentanostucaso',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const DetectorDeFugasRoute = DetectorDeFugasRouteImport.update({
            id: '/detector-de-fugas',path: '/detector-de-fugas',getParentRoute: () => rootRouteImport
          })
const DiagnosticadorLocalesRoute = DiagnosticadorLocalesRouteImport.update({
            id: '/diagnosticador-locales',path: '/diagnosticador-locales',getParentRoute: () => rootRouteImport
          })
const DiagnosticoLocalesComercialesRoute = DiagnosticoLocalesComercialesRouteImport.update({
            id: '/diagnostico-locales-comerciales',path: '/diagnostico-locales-comerciales',getParentRoute: () => rootRouteImport
          })
const EditorialRoute = EditorialRouteImport.update({
            id: '/editorial',path: '/editorial',getParentRoute: () => rootRouteImport
          })
const EstrategiaRoute = EstrategiaRouteImport.update({
            id: '/estrategia',path: '/estrategia',getParentRoute: () => rootRouteImport
          })
const FamilyOfficesInversoresRoute = FamilyOfficesInversoresRouteImport.update({
            id: '/family-offices-inversores',path: '/family-offices-inversores',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const GoRoute = GoRouteImport.update({
            id: '/go',path: '/go',getParentRoute: () => rootRouteImport
          })
const HerramientasParaRetailRoute = HerramientasParaRetailRouteImport.update({
            id: '/herramientas-para-retail',path: '/herramientas-para-retail',getParentRoute: () => rootRouteImport
          })
const HojaDeRutaRoute = HojaDeRutaRouteImport.update({
            id: '/hoja-de-ruta',path: '/hoja-de-ruta',getParentRoute: () => rootRouteImport
          })
const LegalNoticeRoute = LegalNoticeRouteImport.update({
            id: '/legal-notice',path: '/legal-notice',getParentRoute: () => rootRouteImport
          })
const LemonThermometerRoute = LemonThermometerRouteImport.update({
            id: '/lemon-thermometer',path: '/lemon-thermometer',getParentRoute: () => rootRouteImport
          })
const LocationDiagnosisRoute = LocationDiagnosisRouteImport.update({
            id: '/location-diagnosis',path: '/location-diagnosis',getParentRoute: () => rootRouteImport
          })
const MarketingRoute = MarketingRouteImport.update({
            id: '/marketing',path: '/marketing',getParentRoute: () => rootRouteImport
          })
const MensajesRoute = MensajesRouteImport.update({
            id: '/mensajes',path: '/mensajes',getParentRoute: () => rootRouteImport
          })
const MentoriaRoute = MentoriaRouteImport.update({
            id: '/mentoria',path: '/mentoria',getParentRoute: () => rootRouteImport
          })
const MentoriaRetailRoute = MentoriaRetailRouteImport.update({
            id: '/mentoria-retail',path: '/mentoria-retail',getParentRoute: () => rootRouteImport
          })
const MentoringRoute = MentoringRouteImport.update({
            id: '/mentoring',path: '/mentoring',getParentRoute: () => rootRouteImport
          })
const MessagesRoute = MessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => rootRouteImport
          })
const MisLocalesRoute = MisLocalesRouteImport.update({
            id: '/mis-locales',path: '/mis-locales',getParentRoute: () => rootRouteImport
          })
const MusicaParaTuLocalRoute = MusicaParaTuLocalRouteImport.update({
            id: '/musica-para-tu-local',path: '/musica-para-tu-local',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const PresupuestosRoute = PresupuestosRouteImport.update({
            id: '/presupuestos',path: '/presupuestos',getParentRoute: () => rootRouteImport
          })
const PrivacidadRoute = PrivacidadRouteImport.update({
            id: '/privacidad',path: '/privacidad',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ProblemasEnMiTiendaRoute = ProblemasEnMiTiendaRouteImport.update({
            id: '/problemas-en-mi-tienda',path: '/problemas-en-mi-tienda',getParentRoute: () => rootRouteImport
          })
const ProfesionalesRetailRoute = ProfesionalesRetailRouteImport.update({
            id: '/profesionales-retail',path: '/profesionales-retail',getParentRoute: () => rootRouteImport
          })
const ProveedoresRoute = ProveedoresRouteImport.update({
            id: '/proveedores',path: '/proveedores',getParentRoute: () => rootRouteImport
          })
const PublicacionesParaTuLocalRoute = PublicacionesParaTuLocalRouteImport.update({
            id: '/publicaciones-para-tu-local',path: '/publicaciones-para-tu-local',getParentRoute: () => rootRouteImport
          })
const QueEsElAgenteRetailIaRoute = QueEsElAgenteRetailIaRouteImport.update({
            id: '/que-es-el-agente-retail-ia',path: '/que-es-el-agente-retail-ia',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RetailLocationAnalysisRoute = RetailLocationAnalysisRouteImport.update({
            id: '/retail-location-analysis',path: '/retail-location-analysis',getParentRoute: () => rootRouteImport
          })
const RetailProfitabilityCalculatorRoute = RetailProfitabilityCalculatorRouteImport.update({
            id: '/retail-profitability-calculator',path: '/retail-profitability-calculator',getParentRoute: () => rootRouteImport
          })
const TarifasRoute = TarifasRouteImport.update({
            id: '/tarifas',path: '/tarifas',getParentRoute: () => rootRouteImport
          })
const TermometroRoute = TermometroRouteImport.update({
            id: '/termometro',path: '/termometro',getParentRoute: () => rootRouteImport
          })
const TermometroLemonRoute = TermometroLemonRouteImport.update({
            id: '/termometro-lemon',path: '/termometro-lemon',getParentRoute: () => rootRouteImport
          })
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => rootRouteImport
          })
const TestModalRoute = TestModalRouteImport.update({
            id: '/test-modal',path: '/test-modal',getParentRoute: () => rootRouteImport
          })
const TestModalProRoute = TestModalProRouteImport.update({
            id: '/test-modal-pro',path: '/test-modal-pro',getParentRoute: () => rootRouteImport
          })
const TestSupervivenciaRoute = TestSupervivenciaRouteImport.update({
            id: '/test-supervivencia',path: '/test-supervivencia',getParentRoute: () => rootRouteImport
          })
const TodoParaTuComercioRoute = TodoParaTuComercioRouteImport.update({
            id: '/todo-para-tu-comercio',path: '/todo-para-tu-comercio',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminAnaliticaRoute = AdminAnaliticaRouteImport.update({
            id: '/analitica',path: '/analitica',getParentRoute: () => AdminRoute
          })
const AdminAsistentesRoute = AdminAsistentesRouteImport.update({
            id: '/asistentes',path: '/asistentes',getParentRoute: () => AdminRoute
          })
const AdminCalculatorRoute = AdminCalculatorRouteImport.update({
            id: '/calculator',path: '/calculator',getParentRoute: () => AdminRoute
          })
const AdminCasosRealesRoute = AdminCasosRealesRouteImport.update({
            id: '/casos-reales',path: '/casos-reales',getParentRoute: () => AdminRoute
          })
const AdminChatRoute = AdminChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AdminRoute
          })
const AdminClubProRoute = AdminClubProRouteImport.update({
            id: '/club-pro',path: '/club-pro',getParentRoute: () => AdminRoute
          })
const AdminComentariosModulosRoute = AdminComentariosModulosRouteImport.update({
            id: '/comentarios-modulos',path: '/comentarios-modulos',getParentRoute: () => AdminRoute
          })
const AdminComparativaPlanesRoute = AdminComparativaPlanesRouteImport.update({
            id: '/comparativa-planes',path: '/comparativa-planes',getParentRoute: () => AdminRoute
          })
const AdminConsumoIaRoute = AdminConsumoIaRouteImport.update({
            id: '/consumo-ia',path: '/consumo-ia',getParentRoute: () => AdminRoute
          })
const AdminDemoRoute = AdminDemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => AdminRoute
          })
const AdminDiagnosticadorLocalesRoute = AdminDiagnosticadorLocalesRouteImport.update({
            id: '/diagnosticador-locales',path: '/diagnosticador-locales',getParentRoute: () => AdminRoute
          })
const AdminDiagnosticoRoute = AdminDiagnosticoRouteImport.update({
            id: '/diagnostico',path: '/diagnostico',getParentRoute: () => AdminRoute
          })
const AdminEmailsRoute = AdminEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AdminRoute
          })
const AdminEmbudoRoute = AdminEmbudoRouteImport.update({
            id: '/embudo',path: '/embudo',getParentRoute: () => AdminRoute
          })
const AdminErroresRoute = AdminErroresRouteImport.update({
            id: '/errores',path: '/errores',getParentRoute: () => AdminRoute
          })
const AdminFacturacionRoute = AdminFacturacionRouteImport.update({
            id: '/facturacion',path: '/facturacion',getParentRoute: () => AdminRoute
          })
const AdminFacturasRoute = AdminFacturasRouteImport.update({
            id: '/facturas',path: '/facturas',getParentRoute: () => AdminRoute
          })
const AdminFinanzasRoute = AdminFinanzasRouteImport.update({
            id: '/finanzas',path: '/finanzas',getParentRoute: () => AdminRoute
          })
const AdminHeroMessagingRoute = AdminHeroMessagingRouteImport.update({
            id: '/hero-messaging',path: '/hero-messaging',getParentRoute: () => AdminRoute
          })
const AdminInsightsRoute = AdminInsightsRouteImport.update({
            id: '/insights',path: '/insights',getParentRoute: () => AdminRoute
          })
const AdminLandingsRoute = AdminLandingsRouteImport.update({
            id: '/landings',path: '/landings',getParentRoute: () => AdminRoute
          })
const AdminLeadsRoute = AdminLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AdminRoute
          })
const AdminLocalesActivosRoute = AdminLocalesActivosRouteImport.update({
            id: '/locales-activos',path: '/locales-activos',getParentRoute: () => AdminRoute
          })
const AdminMindsetQuotesRoute = AdminMindsetQuotesRouteImport.update({
            id: '/mindset-quotes',path: '/mindset-quotes',getParentRoute: () => AdminRoute
          })
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AdminRoute
          })
const AdminPeticionesHerramientasRoute = AdminPeticionesHerramientasRouteImport.update({
            id: '/peticiones-herramientas',path: '/peticiones-herramientas',getParentRoute: () => AdminRoute
          })
const AdminPlanesRoute = AdminPlanesRouteImport.update({
            id: '/planes',path: '/planes',getParentRoute: () => AdminRoute
          })
const AdminPresupuestosRoute = AdminPresupuestosRouteImport.update({
            id: '/presupuestos',path: '/presupuestos',getParentRoute: () => AdminRoute
          })
const AdminPricingRoute = AdminPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => AdminRoute
          })
const AdminPricingSettingsRoute = AdminPricingSettingsRouteImport.update({
            id: '/pricing-settings',path: '/pricing-settings',getParentRoute: () => AdminRoute
          })
const AdminProfesionalesRoute = AdminProfesionalesRouteImport.update({
            id: '/profesionales',path: '/profesionales',getParentRoute: () => AdminRoute
          })
const AdminQuizRoute = AdminQuizRouteImport.update({
            id: '/quiz',path: '/quiz',getParentRoute: () => AdminRoute
          })
const AdminRoadmapRoute = AdminRoadmapRouteImport.update({
            id: '/roadmap',path: '/roadmap',getParentRoute: () => AdminRoute
          })
const AdminSolucionesRoute = AdminSolucionesRouteImport.update({
            id: '/soluciones',path: '/soluciones',getParentRoute: () => AdminRoute
          })
const AdminSubvencionesRoute = AdminSubvencionesRouteImport.update({
            id: '/subvenciones',path: '/subvenciones',getParentRoute: () => AdminRoute
          })
const AdminSupportAgentRoute = AdminSupportAgentRouteImport.update({
            id: '/support-agent',path: '/support-agent',getParentRoute: () => AdminRoute
          })
const AdminTipsRoute = AdminTipsRouteImport.update({
            id: '/tips',path: '/tips',getParentRoute: () => AdminRoute
          })
const AdminToursRoute = AdminToursRouteImport.update({
            id: '/tours',path: '/tours',getParentRoute: () => AdminRoute
          })
const AdminVipCalendarRoute = AdminVipCalendarRouteImport.update({
            id: '/vip-calendar',path: '/vip-calendar',getParentRoute: () => AdminRoute
          })
const AdminWaitlistRoute = AdminWaitlistRouteImport.update({
            id: '/waitlist',path: '/waitlist',getParentRoute: () => AdminRoute
          })
const AuthErrorRoute = AuthErrorRouteImport.update({
            id: '/auth/error',path: '/auth/error',getParentRoute: () => rootRouteImport
          })
const CasosRealesIndexRoute = CasosRealesIndexRouteImport.update({
            id: '/casos-reales/',path: '/casos-reales/',getParentRoute: () => rootRouteImport
          })
const CasosRealesSlugRoute = CasosRealesSlugRouteImport.update({
            id: '/casos-reales/$slug',path: '/casos-reales/$slug',getParentRoute: () => rootRouteImport
          })
const CheckoutExitoRoute = CheckoutExitoRouteImport.update({
            id: '/checkout/exito',path: '/checkout/exito',getParentRoute: () => rootRouteImport
          })
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
            id: '/checkout/success',path: '/checkout/success',getParentRoute: () => rootRouteImport
          })
const ConsultasResueltasIndexRoute = ConsultasResueltasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ConsultasResueltasRoute
          })
const CuentaFacturacionRoute = CuentaFacturacionRouteImport.update({
            id: '/cuenta/facturacion',path: '/cuenta/facturacion',getParentRoute: () => rootRouteImport
          })
const CuentaPerfilRoute = CuentaPerfilRouteImport.update({
            id: '/cuenta/perfil',path: '/cuenta/perfil',getParentRoute: () => rootRouteImport
          })
const CuentaPresupuestosRoute = CuentaPresupuestosRouteImport.update({
            id: '/cuenta/presupuestos',path: '/cuenta/presupuestos',getParentRoute: () => rootRouteImport
          })
const DebugLogsRoute = DebugLogsRouteImport.update({
            id: '/debug/logs',path: '/debug/logs',getParentRoute: () => rootRouteImport
          })
const EnIndexRoute = EnIndexRouteImport.update({
            id: '/en/',path: '/en/',getParentRoute: () => rootRouteImport
          })
const EnAiAgentRoute = EnAiAgentRouteImport.update({
            id: '/en/ai-agent',path: '/en/ai-agent',getParentRoute: () => rootRouteImport
          })
const EnAnswersRoute = EnAnswersRouteImport.update({
            id: '/en/answers',path: '/en/answers',getParentRoute: () => rootRouteImport
          })
const EnChainsAndFranchisesRoute = EnChainsAndFranchisesRouteImport.update({
            id: '/en/chains-and-franchises',path: '/en/chains-and-franchises',getParentRoute: () => rootRouteImport
          })
const EnContactRoute = EnContactRouteImport.update({
            id: '/en/contact',path: '/en/contact',getParentRoute: () => rootRouteImport
          })
const EnCookiesRoute = EnCookiesRouteImport.update({
            id: '/en/cookies',path: '/en/cookies',getParentRoute: () => rootRouteImport
          })
const EnDashboardRoute = EnDashboardRouteImport.update({
            id: '/en/dashboard',path: '/en/dashboard',getParentRoute: () => rootRouteImport
          })
const EnEditorialRoute = EnEditorialRouteImport.update({
            id: '/en/editorial',path: '/en/editorial',getParentRoute: () => rootRouteImport
          })
const EnEverythingForYourStoreRoute = EnEverythingForYourStoreRouteImport.update({
            id: '/en/everything-for-your-store',path: '/en/everything-for-your-store',getParentRoute: () => rootRouteImport
          })
const EnFamilyOfficesInvestorsRoute = EnFamilyOfficesInvestorsRouteImport.update({
            id: '/en/family-offices-investors',path: '/en/family-offices-investors',getParentRoute: () => rootRouteImport
          })
const EnFaqRoute = EnFaqRouteImport.update({
            id: '/en/faq',path: '/en/faq',getParentRoute: () => rootRouteImport
          })
const EnGoRoute = EnGoRouteImport.update({
            id: '/en/go',path: '/en/go',getParentRoute: () => rootRouteImport
          })
const EnHowItWorksRoute = EnHowItWorksRouteImport.update({
            id: '/en/how-it-works',path: '/en/how-it-works',getParentRoute: () => rootRouteImport
          })
const EnLeakDetectorRoute = EnLeakDetectorRouteImport.update({
            id: '/en/leak-detector',path: '/en/leak-detector',getParentRoute: () => rootRouteImport
          })
const EnLegalNoticeRoute = EnLegalNoticeRouteImport.update({
            id: '/en/legal-notice',path: '/en/legal-notice',getParentRoute: () => rootRouteImport
          })
const EnLemonThermometerRoute = EnLemonThermometerRouteImport.update({
            id: '/en/lemon-thermometer',path: '/en/lemon-thermometer',getParentRoute: () => rootRouteImport
          })
const EnMarketingRoute = EnMarketingRouteImport.update({
            id: '/en/marketing',path: '/en/marketing',getParentRoute: () => rootRouteImport
          })
const EnMentoringRoute = EnMentoringRouteImport.update({
            id: '/en/mentoring',path: '/en/mentoring',getParentRoute: () => rootRouteImport
          })
const EnMusicForYourStoreRoute = EnMusicForYourStoreRouteImport.update({
            id: '/en/music-for-your-store',path: '/en/music-for-your-store',getParentRoute: () => rootRouteImport
          })
const EnOpenAStoreInSpainRoute = EnOpenAStoreInSpainRouteImport.update({
            id: '/en/open-a-store-in-spain',path: '/en/open-a-store-in-spain',getParentRoute: () => rootRouteImport
          })
const EnPartnersRoute = EnPartnersRouteImport.update({
            id: '/en/partners',path: '/en/partners',getParentRoute: () => rootRouteImport
          })
const EnPricingRoute = EnPricingRouteImport.update({
            id: '/en/pricing',path: '/en/pricing',getParentRoute: () => rootRouteImport
          })
const EnPrivacyPolicyRoute = EnPrivacyPolicyRouteImport.update({
            id: '/en/privacy-policy',path: '/en/privacy-policy',getParentRoute: () => rootRouteImport
          })
const EnRetailAiAgentRoute = EnRetailAiAgentRouteImport.update({
            id: '/en/retail-ai-agent',path: '/en/retail-ai-agent',getParentRoute: () => rootRouteImport
          })
const EnRetailExpertsRoute = EnRetailExpertsRouteImport.update({
            id: '/en/retail-experts',path: '/en/retail-experts',getParentRoute: () => rootRouteImport
          })
const EnRetailLocationAnalysisRoute = EnRetailLocationAnalysisRouteImport.update({
            id: '/en/retail-location-analysis',path: '/en/retail-location-analysis',getParentRoute: () => rootRouteImport
          })
const EnRetailProfitabilityCalculatorRoute = EnRetailProfitabilityCalculatorRouteImport.update({
            id: '/en/retail-profitability-calculator',path: '/en/retail-profitability-calculator',getParentRoute: () => rootRouteImport
          })
const EnRetailRoadmapRoute = EnRetailRoadmapRouteImport.update({
            id: '/en/retail-roadmap',path: '/en/retail-roadmap',getParentRoute: () => rootRouteImport
          })
const EnRetailSurvivalTestRoute = EnRetailSurvivalTestRouteImport.update({
            id: '/en/retail-survival-test',path: '/en/retail-survival-test',getParentRoute: () => rootRouteImport
          })
const EnScentForYourStoreRoute = EnScentForYourStoreRouteImport.update({
            id: '/en/scent-for-your-store',path: '/en/scent-for-your-store',getParentRoute: () => rootRouteImport
          })
const EnSocialPostsForYourStoreRoute = EnSocialPostsForYourStoreRouteImport.update({
            id: '/en/social-posts-for-your-store',path: '/en/social-posts-for-your-store',getParentRoute: () => rootRouteImport
          })
const EnStoreProblemsRoute = EnStoreProblemsRouteImport.update({
            id: '/en/store-problems',path: '/en/store-problems',getParentRoute: () => rootRouteImport
          })
const EnStrategyRoute = EnStrategyRouteImport.update({
            id: '/en/strategy',path: '/en/strategy',getParentRoute: () => rootRouteImport
          })
const EnSuppliersRoute = EnSuppliersRouteImport.update({
            id: '/en/suppliers',path: '/en/suppliers',getParentRoute: () => rootRouteImport
          })
const EnTarifasRoute = EnTarifasRouteImport.update({
            id: '/en/tarifas',path: '/en/tarifas',getParentRoute: () => rootRouteImport
          })
const EnTermsRoute = EnTermsRouteImport.update({
            id: '/en/terms',path: '/en/terms',getParentRoute: () => rootRouteImport
          })
const EnTipsRoute = EnTipsRouteImport.update({
            id: '/en/tips',path: '/en/tips',getParentRoute: () => rootRouteImport
          })
const EnToolsForRetailRoute = EnToolsForRetailRouteImport.update({
            id: '/en/tools-for-retail',path: '/en/tools-for-retail',getParentRoute: () => rootRouteImport
          })
const EnWhatIsTheRetailAiAgentRoute = EnWhatIsTheRetailAiAgentRouteImport.update({
            id: '/en/what-is-the-retail-ai-agent',path: '/en/what-is-the-retail-ai-agent',getParentRoute: () => rootRouteImport
          })
const GuiasIndexRoute = GuiasIndexRouteImport.update({
            id: '/guias/',path: '/guias/',getParentRoute: () => rootRouteImport
          })
const GuiasSlugRoute = GuiasSlugRouteImport.update({
            id: '/guias/$slug',path: '/guias/$slug',getParentRoute: () => rootRouteImport
          })
const HerramientasIndexRoute = HerramientasIndexRouteImport.update({
            id: '/herramientas/',path: '/herramientas/',getParentRoute: () => rootRouteImport
          })
const HerramientasAnalisisCompletoRoute = HerramientasAnalisisCompletoRouteImport.update({
            id: '/herramientas/analisis-completo',path: '/herramientas/analisis-completo',getParentRoute: () => rootRouteImport
          })
const HerramientasCalculadoraRoute = HerramientasCalculadoraRouteImport.update({
            id: '/herramientas/calculadora',path: '/herramientas/calculadora',getParentRoute: () => rootRouteImport
          })
const HerramientasKpisRoute = HerramientasKpisRouteImport.update({
            id: '/herramientas/kpis',path: '/herramientas/kpis',getParentRoute: () => rootRouteImport
          })
const HerramientasMisLocalesRoute = HerramientasMisLocalesRouteImport.update({
            id: '/herramientas/mis-locales',path: '/herramientas/mis-locales',getParentRoute: () => rootRouteImport
          })
const HerramientasPresupuestosRoute = HerramientasPresupuestosRouteImport.update({
            id: '/herramientas/presupuestos',path: '/herramientas/presupuestos',getParentRoute: () => rootRouteImport
          })
const HerramientasProveedoresRoute = HerramientasProveedoresRouteImport.update({
            id: '/herramientas/proveedores',path: '/herramientas/proveedores',getParentRoute: () => rootRouteImport
          })
const HerramientasTermometroRoute = HerramientasTermometroRouteImport.update({
            id: '/herramientas/termometro',path: '/herramientas/termometro',getParentRoute: () => rootRouteImport
          })
const InsightsIndexRoute = InsightsIndexRouteImport.update({
            id: '/insights/',path: '/insights/',getParentRoute: () => rootRouteImport
          })
const InsightsSlugRoute = InsightsSlugRouteImport.update({
            id: '/insights/$slug',path: '/insights/$slug',getParentRoute: () => rootRouteImport
          })
const LpInstagramRoute = LpInstagramRouteImport.update({
            id: '/lp/instagram',path: '/lp/instagram',getParentRoute: () => rootRouteImport
          })
const LpSupervivenciaRoute = LpSupervivenciaRouteImport.update({
            id: '/lp/supervivencia',path: '/lp/supervivencia',getParentRoute: () => rootRouteImport
          })
const LpTestSupervivenciaRoute = LpTestSupervivenciaRouteImport.update({
            id: '/lp/test-supervivencia',path: '/lp/test-supervivencia',getParentRoute: () => rootRouteImport
          })
const PanelIndexRoute = PanelIndexRouteImport.update({
            id: '/panel/',path: '/panel/',getParentRoute: () => rootRouteImport
          })
const PanelCalculadoraProRoute = PanelCalculadoraProRouteImport.update({
            id: '/panel/calculadora-pro',path: '/panel/calculadora-pro',getParentRoute: () => rootRouteImport
          })
const PanelCasosRoute = PanelCasosRouteImport.update({
            id: '/panel/casos',path: '/panel/casos',getParentRoute: () => rootRouteImport
          })
const PanelSubvencionesRoute = PanelSubvencionesRouteImport.update({
            id: '/panel/subvenciones',path: '/panel/subvenciones',getParentRoute: () => rootRouteImport
          })
const RecursosSubvencionesRoute = RecursosSubvencionesRouteImport.update({
            id: '/recursos/subvenciones',path: '/recursos/subvenciones',getParentRoute: () => rootRouteImport
          })
const SubvencionesIndexRoute = SubvencionesIndexRouteImport.update({
            id: '/subvenciones/',path: '/subvenciones/',getParentRoute: () => rootRouteImport
          })
const SubvencionesCodigoRoute = SubvencionesCodigoRouteImport.update({
            id: '/subvenciones/$codigo',path: '/subvenciones/$codigo',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AdminCrmIndexRoute = AdminCrmIndexRouteImport.update({
            id: '/crm/',path: '/crm/',getParentRoute: () => AdminRoute
          })
const ConsultasResueltasSectorPreguntaRoute = ConsultasResueltasSectorPreguntaRouteImport.update({
            id: '/$sector/$pregunta',path: '/$sector/$pregunta',getParentRoute: () => ConsultasResueltasRoute
          })
const EnAccountBillingRoute = EnAccountBillingRouteImport.update({
            id: '/en/account/billing',path: '/en/account/billing',getParentRoute: () => rootRouteImport
          })
const EnAccountProfileRoute = EnAccountProfileRouteImport.update({
            id: '/en/account/profile',path: '/en/account/profile',getParentRoute: () => rootRouteImport
          })
const EnAccountQuotesRoute = EnAccountQuotesRouteImport.update({
            id: '/en/account/quotes',path: '/en/account/quotes',getParentRoute: () => rootRouteImport
          })
const EnAnswersIndexRoute = EnAnswersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EnAnswersRoute
          })
const EnGrantsIndexRoute = EnGrantsIndexRouteImport.update({
            id: '/en/grants/',path: '/en/grants/',getParentRoute: () => rootRouteImport
          })
const EnGrantsCodigoRoute = EnGrantsCodigoRouteImport.update({
            id: '/en/grants/$codigo',path: '/en/grants/$codigo',getParentRoute: () => rootRouteImport
          })
const EnGuidesIndexRoute = EnGuidesIndexRouteImport.update({
            id: '/en/guides/',path: '/en/guides/',getParentRoute: () => rootRouteImport
          })
const EnGuidesSlugRoute = EnGuidesSlugRouteImport.update({
            id: '/en/guides/$slug',path: '/en/guides/$slug',getParentRoute: () => rootRouteImport
          })
const EnInsightsIndexRoute = EnInsightsIndexRouteImport.update({
            id: '/en/insights/',path: '/en/insights/',getParentRoute: () => rootRouteImport
          })
const EnInsightsSlugRoute = EnInsightsSlugRouteImport.update({
            id: '/en/insights/$slug',path: '/en/insights/$slug',getParentRoute: () => rootRouteImport
          })
const EnLpInstagramRoute = EnLpInstagramRouteImport.update({
            id: '/en/lp/instagram',path: '/en/lp/instagram',getParentRoute: () => rootRouteImport
          })
const EnPanelIndexRoute = EnPanelIndexRouteImport.update({
            id: '/en/panel/',path: '/en/panel/',getParentRoute: () => rootRouteImport
          })
const EnPanelCasesRoute = EnPanelCasesRouteImport.update({
            id: '/en/panel/cases',path: '/en/panel/cases',getParentRoute: () => rootRouteImport
          })
const EnPanelGrantsRoute = EnPanelGrantsRouteImport.update({
            id: '/en/panel/grants',path: '/en/panel/grants',getParentRoute: () => rootRouteImport
          })
const EnPanelProCalculatorRoute = EnPanelProCalculatorRouteImport.update({
            id: '/en/panel/pro-calculator',path: '/en/panel/pro-calculator',getParentRoute: () => rootRouteImport
          })
const EnRealCasesIndexRoute = EnRealCasesIndexRouteImport.update({
            id: '/en/real-cases/',path: '/en/real-cases/',getParentRoute: () => rootRouteImport
          })
const EnRealCasesSlugRoute = EnRealCasesSlugRouteImport.update({
            id: '/en/real-cases/$slug',path: '/en/real-cases/$slug',getParentRoute: () => rootRouteImport
          })
const EnResourcesSubsidiesRoute = EnResourcesSubsidiesRouteImport.update({
            id: '/en/resources/subsidies',path: '/en/resources/subsidies',getParentRoute: () => rootRouteImport
          })
const EnToolsIndexRoute = EnToolsIndexRouteImport.update({
            id: '/en/tools/',path: '/en/tools/',getParentRoute: () => rootRouteImport
          })
const EnToolsCalculatorRoute = EnToolsCalculatorRouteImport.update({
            id: '/en/tools/calculator',path: '/en/tools/calculator',getParentRoute: () => rootRouteImport
          })
const EnToolsKpisRoute = EnToolsKpisRouteImport.update({
            id: '/en/tools/kpis',path: '/en/tools/kpis',getParentRoute: () => rootRouteImport
          })
const EnToolsLemonThermometerRoute = EnToolsLemonThermometerRouteImport.update({
            id: '/en/tools/lemon-thermometer',path: '/en/tools/lemon-thermometer',getParentRoute: () => rootRouteImport
          })
const EnToolsMyPremisesRoute = EnToolsMyPremisesRouteImport.update({
            id: '/en/tools/my-premises',path: '/en/tools/my-premises',getParentRoute: () => rootRouteImport
          })
const EnToolsProposalsRoute = EnToolsProposalsRouteImport.update({
            id: '/en/tools/proposals',path: '/en/tools/proposals',getParentRoute: () => rootRouteImport
          })
const EnToolsSuppliersRoute = EnToolsSuppliersRouteImport.update({
            id: '/en/tools/suppliers',path: '/en/tools/suppliers',getParentRoute: () => rootRouteImport
          })
const SubvencionesSectorSectorRoute = SubvencionesSectorSectorRouteImport.update({
            id: '/subvenciones/sector/$sector',path: '/subvenciones/sector/$sector',getParentRoute: () => rootRouteImport
          })
const SubvencionesTerritorioComunidadRoute = SubvencionesTerritorioComunidadRouteImport.update({
            id: '/subvenciones/territorio/$comunidad',path: '/subvenciones/territorio/$comunidad',getParentRoute: () => rootRouteImport
          })
const AdminCrmUserIdIndexRoute = AdminCrmUserIdIndexRouteImport.update({
            id: '/crm/$userId/',path: '/crm/$userId/',getParentRoute: () => AdminRoute
          })
const AdminCrmUserIdPanelRoute = AdminCrmUserIdPanelRouteImport.update({
            id: '/crm/$userId/panel',path: '/crm/$userId/panel',getParentRoute: () => AdminRoute
          })
const CuentaHistorialDiagnosticoSessionIdRoute = CuentaHistorialDiagnosticoSessionIdRouteImport.update({
            id: '/cuenta/historial/diagnostico/$sessionId',path: '/cuenta/historial/diagnostico/$sessionId',getParentRoute: () => rootRouteImport
          })
const EnAnswersSectorQuestionRoute = EnAnswersSectorQuestionRouteImport.update({
            id: '/$sector/$question',path: '/$sector/$question',getParentRoute: () => EnAnswersRoute
          })
const EnGrantsRegionComunidadRoute = EnGrantsRegionComunidadRouteImport.update({
            id: '/en/grants/region/$comunidad',path: '/en/grants/region/$comunidad',getParentRoute: () => rootRouteImport
          })
const EnGrantsSectorSectorRoute = EnGrantsSectorSectorRouteImport.update({
            id: '/en/grants/sector/$sector',path: '/en/grants/sector/$sector',getParentRoute: () => rootRouteImport
          })





const AdminRouteChildren = {
  AdminAnaliticaRoute: AdminAnaliticaRoute,AdminAsistentesRoute: AdminAsistentesRoute,AdminCalculatorRoute: AdminCalculatorRoute,AdminCasosRealesRoute: AdminCasosRealesRoute,AdminChatRoute: AdminChatRoute,AdminClubProRoute: AdminClubProRoute,AdminComentariosModulosRoute: AdminComentariosModulosRoute,AdminComparativaPlanesRoute: AdminComparativaPlanesRoute,AdminConsumoIaRoute: AdminConsumoIaRoute,AdminDemoRoute: AdminDemoRoute,AdminDiagnosticadorLocalesRoute: AdminDiagnosticadorLocalesRoute,AdminDiagnosticoRoute: AdminDiagnosticoRoute,AdminEmailsRoute: AdminEmailsRoute,AdminEmbudoRoute: AdminEmbudoRoute,AdminErroresRoute: AdminErroresRoute,AdminFacturacionRoute: AdminFacturacionRoute,AdminFacturasRoute: AdminFacturasRoute,AdminFinanzasRoute: AdminFinanzasRoute,AdminHeroMessagingRoute: AdminHeroMessagingRoute,AdminInsightsRoute: AdminInsightsRoute,AdminLandingsRoute: AdminLandingsRoute,AdminLeadsRoute: AdminLeadsRoute,AdminLocalesActivosRoute: AdminLocalesActivosRoute,AdminMindsetQuotesRoute: AdminMindsetQuotesRoute,AdminPaymentsRoute: AdminPaymentsRoute,AdminPeticionesHerramientasRoute: AdminPeticionesHerramientasRoute,AdminPlanesRoute: AdminPlanesRoute,AdminPresupuestosRoute: AdminPresupuestosRoute,AdminPricingRoute: AdminPricingRoute,AdminPricingSettingsRoute: AdminPricingSettingsRoute,AdminProfesionalesRoute: AdminProfesionalesRoute,AdminQuizRoute: AdminQuizRoute,AdminRoadmapRoute: AdminRoadmapRoute,AdminSolucionesRoute: AdminSolucionesRoute,AdminSubvencionesRoute: AdminSubvencionesRoute,AdminSupportAgentRoute: AdminSupportAgentRoute,AdminTipsRoute: AdminTipsRoute,AdminToursRoute: AdminToursRoute,AdminVipCalendarRoute: AdminVipCalendarRoute,AdminWaitlistRoute: AdminWaitlistRoute,AdminIndexRoute: AdminIndexRoute,AdminCrmIndexRoute: AdminCrmIndexRoute,AdminCrmUserIdPanelRoute: AdminCrmUserIdPanelRoute,AdminCrmUserIdIndexRoute: AdminCrmUserIdIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const ConsultasResueltasRouteChildren = {
  ConsultasResueltasIndexRoute: ConsultasResueltasIndexRoute,ConsultasResueltasSectorPreguntaRoute: ConsultasResueltasSectorPreguntaRoute
}

const ConsultasResueltasRouteWithChildren = ConsultasResueltasRoute._addFileChildren(ConsultasResueltasRouteChildren)




const EnAnswersRouteChildren = {
  EnAnswersIndexRoute: EnAnswersIndexRoute,EnAnswersSectorQuestionRoute: EnAnswersSectorQuestionRoute
}

const EnAnswersRouteWithChildren = EnAnswersRoute._addFileChildren(EnAnswersRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AbrirTiendaEnEspanaRoute: AbrirTiendaEnEspanaRoute,AdminRoute: AdminRouteWithChildren,AgenteIaRoute: AgenteIaRoute,AgenteRetailIaRoute: AgenteRetailIaRoute,AnalisisCompletoRoute: AnalisisCompletoRoute,AromaParaTuLocalRoute: AromaParaTuLocalRoute,AvisoLegalRoute: AvisoLegalRoute,CadenasYFranquiciasRoute: CadenasYFranquiciasRoute,CalculadoraRoute: CalculadoraRoute,CalculadoraRentabilidadRetailRoute: CalculadoraRentabilidadRetailRoute,CasosRealesRetailRoute: CasosRealesRetailRoute,ColaboradoresRoute: ColaboradoresRoute,ComoFuncionaRoute: ComoFuncionaRoute,CondicionesContratacionRoute: CondicionesContratacionRoute,ConsejosRoute: ConsejosRoute,ConsultasResueltasRoute: ConsultasResueltasRouteWithChildren,ContactRoute: ContactRoute,ContactoRoute: ContactoRoute,CookiePolicyRoute: CookiePolicyRoute,CookiesRoute: CookiesRoute,CuentanostucasoRoute: CuentanostucasoRoute,DashboardRoute: DashboardRoute,DetectorDeFugasRoute: DetectorDeFugasRoute,DiagnosticadorLocalesRoute: DiagnosticadorLocalesRoute,DiagnosticoLocalesComercialesRoute: DiagnosticoLocalesComercialesRoute,EditorialRoute: EditorialRoute,EstrategiaRoute: EstrategiaRoute,FamilyOfficesInversoresRoute: FamilyOfficesInversoresRoute,FaqRoute: FaqRoute,GoRoute: GoRoute,HerramientasParaRetailRoute: HerramientasParaRetailRoute,HojaDeRutaRoute: HojaDeRutaRoute,LegalNoticeRoute: LegalNoticeRoute,LemonThermometerRoute: LemonThermometerRoute,LocationDiagnosisRoute: LocationDiagnosisRoute,MarketingRoute: MarketingRoute,MensajesRoute: MensajesRoute,MentoriaRoute: MentoriaRoute,MentoriaRetailRoute: MentoriaRetailRoute,MentoringRoute: MentoringRoute,MessagesRoute: MessagesRoute,MisLocalesRoute: MisLocalesRoute,MusicaParaTuLocalRoute: MusicaParaTuLocalRoute,OnboardingRoute: OnboardingRoute,PresupuestosRoute: PresupuestosRoute,PrivacidadRoute: PrivacidadRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ProblemasEnMiTiendaRoute: ProblemasEnMiTiendaRoute,ProfesionalesRetailRoute: ProfesionalesRetailRoute,ProveedoresRoute: ProveedoresRoute,PublicacionesParaTuLocalRoute: PublicacionesParaTuLocalRoute,QueEsElAgenteRetailIaRoute: QueEsElAgenteRetailIaRoute,ResetPasswordRoute: ResetPasswordRoute,RetailLocationAnalysisRoute: RetailLocationAnalysisRoute,RetailProfitabilityCalculatorRoute: RetailProfitabilityCalculatorRoute,TarifasRoute: TarifasRoute,TermometroRoute: TermometroRoute,TermometroLemonRoute: TermometroLemonRoute,TermsOfServiceRoute: TermsOfServiceRoute,TestModalRoute: TestModalRoute,TestModalProRoute: TestModalProRoute,TestSupervivenciaRoute: TestSupervivenciaRoute,TodoParaTuComercioRoute: TodoParaTuComercioRoute,AuthErrorRoute: AuthErrorRoute,CasosRealesSlugRoute: CasosRealesSlugRoute,CheckoutExitoRoute: CheckoutExitoRoute,CheckoutSuccessRoute: CheckoutSuccessRoute,CuentaFacturacionRoute: CuentaFacturacionRoute,CuentaPerfilRoute: CuentaPerfilRoute,CuentaPresupuestosRoute: CuentaPresupuestosRoute,DebugLogsRoute: DebugLogsRoute,EnAiAgentRoute: EnAiAgentRoute,EnAnswersRoute: EnAnswersRouteWithChildren,EnChainsAndFranchisesRoute: EnChainsAndFranchisesRoute,EnContactRoute: EnContactRoute,EnCookiesRoute: EnCookiesRoute,EnDashboardRoute: EnDashboardRoute,EnEditorialRoute: EnEditorialRoute,EnEverythingForYourStoreRoute: EnEverythingForYourStoreRoute,EnFamilyOfficesInvestorsRoute: EnFamilyOfficesInvestorsRoute,EnFaqRoute: EnFaqRoute,EnGoRoute: EnGoRoute,EnHowItWorksRoute: EnHowItWorksRoute,EnLeakDetectorRoute: EnLeakDetectorRoute,EnLegalNoticeRoute: EnLegalNoticeRoute,EnLemonThermometerRoute: EnLemonThermometerRoute,EnMarketingRoute: EnMarketingRoute,EnMentoringRoute: EnMentoringRoute,EnMusicForYourStoreRoute: EnMusicForYourStoreRoute,EnOpenAStoreInSpainRoute: EnOpenAStoreInSpainRoute,EnPartnersRoute: EnPartnersRoute,EnPricingRoute: EnPricingRoute,EnPrivacyPolicyRoute: EnPrivacyPolicyRoute,EnRetailAiAgentRoute: EnRetailAiAgentRoute,EnRetailExpertsRoute: EnRetailExpertsRoute,EnRetailLocationAnalysisRoute: EnRetailLocationAnalysisRoute,EnRetailProfitabilityCalculatorRoute: EnRetailProfitabilityCalculatorRoute,EnRetailRoadmapRoute: EnRetailRoadmapRoute,EnRetailSurvivalTestRoute: EnRetailSurvivalTestRoute,EnScentForYourStoreRoute: EnScentForYourStoreRoute,EnSocialPostsForYourStoreRoute: EnSocialPostsForYourStoreRoute,EnStoreProblemsRoute: EnStoreProblemsRoute,EnStrategyRoute: EnStrategyRoute,EnSuppliersRoute: EnSuppliersRoute,EnTarifasRoute: EnTarifasRoute,EnTermsRoute: EnTermsRoute,EnTipsRoute: EnTipsRoute,EnToolsForRetailRoute: EnToolsForRetailRoute,EnWhatIsTheRetailAiAgentRoute: EnWhatIsTheRetailAiAgentRoute,GuiasSlugRoute: GuiasSlugRoute,HerramientasAnalisisCompletoRoute: HerramientasAnalisisCompletoRoute,HerramientasCalculadoraRoute: HerramientasCalculadoraRoute,HerramientasKpisRoute: HerramientasKpisRoute,HerramientasMisLocalesRoute: HerramientasMisLocalesRoute,HerramientasPresupuestosRoute: HerramientasPresupuestosRoute,HerramientasProveedoresRoute: HerramientasProveedoresRoute,HerramientasTermometroRoute: HerramientasTermometroRoute,InsightsSlugRoute: InsightsSlugRoute,LpInstagramRoute: LpInstagramRoute,LpSupervivenciaRoute: LpSupervivenciaRoute,LpTestSupervivenciaRoute: LpTestSupervivenciaRoute,PanelCalculadoraProRoute: PanelCalculadoraProRoute,PanelCasosRoute: PanelCasosRoute,PanelSubvencionesRoute: PanelSubvencionesRoute,RecursosSubvencionesRoute: RecursosSubvencionesRoute,SubvencionesCodigoRoute: SubvencionesCodigoRoute,CasosRealesIndexRoute: CasosRealesIndexRoute,EnIndexRoute: EnIndexRoute,GuiasIndexRoute: GuiasIndexRoute,HerramientasIndexRoute: HerramientasIndexRoute,InsightsIndexRoute: InsightsIndexRoute,PanelIndexRoute: PanelIndexRoute,SubvencionesIndexRoute: SubvencionesIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,EnAccountBillingRoute: EnAccountBillingRoute,EnAccountProfileRoute: EnAccountProfileRoute,EnAccountQuotesRoute: EnAccountQuotesRoute,EnGrantsCodigoRoute: EnGrantsCodigoRoute,EnGuidesSlugRoute: EnGuidesSlugRoute,EnInsightsSlugRoute: EnInsightsSlugRoute,EnLpInstagramRoute: EnLpInstagramRoute,EnPanelCasesRoute: EnPanelCasesRoute,EnPanelGrantsRoute: EnPanelGrantsRoute,EnPanelProCalculatorRoute: EnPanelProCalculatorRoute,EnRealCasesSlugRoute: EnRealCasesSlugRoute,EnResourcesSubsidiesRoute: EnResourcesSubsidiesRoute,EnToolsCalculatorRoute: EnToolsCalculatorRoute,EnToolsKpisRoute: EnToolsKpisRoute,EnToolsLemonThermometerRoute: EnToolsLemonThermometerRoute,EnToolsMyPremisesRoute: EnToolsMyPremisesRoute,EnToolsProposalsRoute: EnToolsProposalsRoute,EnToolsSuppliersRoute: EnToolsSuppliersRoute,SubvencionesSectorSectorRoute: SubvencionesSectorSectorRoute,SubvencionesTerritorioComunidadRoute: SubvencionesTerritorioComunidadRoute,EnGrantsIndexRoute: EnGrantsIndexRoute,EnGuidesIndexRoute: EnGuidesIndexRoute,EnInsightsIndexRoute: EnInsightsIndexRoute,EnPanelIndexRoute: EnPanelIndexRoute,EnRealCasesIndexRoute: EnRealCasesIndexRoute,EnToolsIndexRoute: EnToolsIndexRoute,CuentaHistorialDiagnosticoSessionIdRoute: CuentaHistorialDiagnosticoSessionIdRoute,EnGrantsRegionComunidadRoute: EnGrantsRegionComunidadRoute,EnGrantsSectorSectorRoute: EnGrantsSectorSectorRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)